import { Jaco } from "./Jaco";
import { Jaco3d } from "../arrangement3d/Jaco3d";

export class LazyPool<T> {
  usedLength: number = 0;
  jaco: Jaco;
  array: T[];
  jacoCreator: () => T;
  jaco3DCreator?: (index: number) => Jaco3d | null;

  constructor(
    jaco: Jaco,
    array: T[],
    jacoCreator: () => T,
    jaco3DCreator?: (index: number) => Jaco3d | null,
  ) {
    this.jaco = jaco;
    this.array = array;
    this.jacoCreator = jacoCreator;
    this.jaco3DCreator = jaco3DCreator;
  }

  get(i: number): T {
    this.usedLength = Math.max(this.usedLength, i + 1);
    while (i + 1 > this.array.length) {
      this.array.push(this.jacoCreator());
    }
    const entry = this.array[i];
    if (this.jaco3DCreator) {
      this.jaco.lazyCreateOrTouch3d(this.jaco3DCreator(i) as any);
    }
    return entry;
  }

  next(): T {
    return this.get(this.usedLength);
  }

  cleanup(): T[] {
    if (this.array.length > this.usedLength) {
      const toDelete = this.array.slice(this.usedLength);
      this.array.splice(this.usedLength, this.array.length - this.usedLength);
      return toDelete;
    }
    return [];
  }

  findOrCreate(predicate: (item: T) => boolean): T {
    const i = this.array.findIndex(predicate);
    return this._getIndexOrCreate(i);
  }

  pickOrCreate(pick: (array: T[]) => T): T {
    const element = pick(this.array);
    const i = this.array.findIndex((e) => e === element);
    return this._getIndexOrCreate(i);
  }

  private _getIndexOrCreate(i: number): T {
    if (i >= this.usedLength) {
      // Tausch das gefundene Element mit dem ersten ungenutzten Element
      const nextUnused = this.array[this.usedLength];
      this.array[this.usedLength] = this.array[i];
      this.array[i] = nextUnused;
      return this.get(this.usedLength);
    }
    if (i >= 0) {
      return this.get(i);
    }
    return this.next();
  }
}
